import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { Globals } from '@app/service/globals.service';

@Injectable()
export class HAuthService {

  private isHomeLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private homeLoginData: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  get getIsHomeLogin() {
    return this.isHomeLogin.asObservable();
  }

  get getHomeLoginData() {
    return this.homeLoginData.asObservable();
  }

  constructor(
    private router: Router,
    private globals: Globals,
  ) {}

  /*******************************************************************************
    설  명 : 로그인
  *******************************************************************************/
  login(response: any) {
    this.isHomeLogin.next(true);
    this.homeLoginData.next(response.data);
    this.globals.setToken(response.token);
  }

  /*******************************************************************************
    설  명 : 로그아웃
  *******************************************************************************/
  logout() {
    this.isHomeLogin.next(false);
    this.homeLoginData.next([]);
    this.globals.clearToken();
  }

}
